import {SmartComponent} from "smart-component-js";

class NewsListComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.page = 1;
        this.pageSize = 9;
        this.pageVisibilityLimit = 3;
        this.count = this.element.querySelectorAll('.single-card').length;
        this.prev = this.element.querySelector('#prev');
        this.next = this.element.querySelector('#next');
        this.init();
    }

    paginationManager() {
        const pageWrapper = this.element.querySelector('.news-list__pagination-wrapper');
        let buttons = "";
        this.numberOfPages = Math.ceil(this.count / this.pageSize);

        for (let i = 1; i <= this.numberOfPages; i++) buttons += this.buildPaginationButton(i);
        pageWrapper.innerHTML = buttons;
        this.addPaginationListener();
        this.updatePrevNext();
    }

    buildPaginationButton(index) {
        let pageParam = "";

        const selectedClass = (this.page === index) ? 'active' : '';
        const hiddenClass = (index <= this.pageVisibilityLimit || (index === this.numberOfPages)) ? '' : 'hidden';
        const hiddenEllipsisClass = (this.numberOfPages > this.pageVisibilityLimit) ? '' : 'hidden';

        if (index === this.numberOfPages) pageParam += `<button class="news-list__pagination-number last ${hiddenEllipsisClass}" disabled="disabled">...</button>`;
        pageParam += `<button data-index="${index}" class="news-list__pagination-number ${selectedClass} ${hiddenClass}">${index}</button>`;
        if (index === 1) pageParam += `<button class="news-list__pagination-number first hidden" disabled="disabled">...</button>`;

        return pageParam;
    }

    addPaginationListener() {
        this.pageButton = this.element.querySelectorAll('.news-list__pagination-number');
        this.pageButton.forEach((el) => {
            el.addEventListener('click', () => {
                this.page = parseInt(el.dataset.index);
                this.updatePaginationIndex(this.page);
            })
        })
    }

    updatePaginationIndex(index) {
        this.setNewsVisibility();

        this.element.querySelector(`.news-list__pagination-number.active`).classList.remove('active');
        this.element.querySelector(`button[data-index="${index}"]`).classList.add('active');

        this.updatePrevNext();
        if (this.numberOfPages <= this.pageVisibilityLimit) return;

        this.visibleElement = this.getVisiblePaginationRange();
        this.element.querySelectorAll('.news-list__pagination-number').forEach((button) => button.classList.add('hidden'));
        this.visibleElement.forEach((button) => button.classList.remove('hidden'));

        (this.numberOfPages > this.pageVisibilityLimit) && this.updateEllipsisVisibility();
    }

    getVisiblePaginationRange() {
        if (this.numberOfPages <= this.pageVisibilityLimit)
            return this.element.querySelectorAll('.news-list__pagination-number');

        const visibleRange = [];
        let paginationDelta = 1;
        visibleRange.push(this.element.querySelector(`button[data-index="${this.page}"]`));

        while (visibleRange.length < this.pageVisibilityLimit) {
            const buttonLeft = this.element.querySelector(`button[data-index="${this.page + paginationDelta}"]`);
            const buttonRight = this.element.querySelector(`button[data-index="${this.page - paginationDelta}"]`);
            buttonLeft && visibleRange.push(buttonLeft);
            buttonRight && visibleRange.push(buttonRight);
            paginationDelta++;
        }

        return visibleRange;
    }

    updateEllipsisVisibility() {
        const firstEllipsis = this.element.querySelector('.news-list__pagination-number.first');
        (this.page <= 2) ? firstEllipsis.classList.add('hidden') : firstEllipsis.classList.remove('hidden');
        const lastEllipsis = this.element.querySelector('.news-list__pagination-number.last');
        (this.page > this.numberOfPages - 2) ? lastEllipsis.classList.add('hidden') : lastEllipsis.classList.remove('hidden');
    }

    updatePrevNext() {
        (this.page === 1) ? this.prev.setAttribute('disabled', 'disabled') : this.prev.removeAttribute('disabled');
        (this.page < this.numberOfPages) ? this.next.removeAttribute('disabled') : this.next.setAttribute('disabled', 'disabled');
    }

    addPaginationButtonListener() {
        this.prev = this.element.querySelector('#prev');
        this.prev.addEventListener('click', () => {
            this.page -= 1;
            this.updatePaginationIndex(this.page);

        })

        this.next = this.element.querySelector('#next');
        this.next.addEventListener('click', () => {
            this.page += 1;
            this.updatePaginationIndex(this.page);
        });
    }


    setNewsVisibility() {
        const visibleCards = this.element.querySelectorAll('.news-list__item.visible');
        visibleCards.forEach(card => card.classList.remove('visible'));

        const startIndex = ((this.page - 1) * this.pageSize);
        const endIndex = (this.page * this.pageSize);

        for (let index = startIndex; index < endIndex; index++) {
            this.element.querySelector(`.news-list__item[data-index="${index}"]`)?.classList.add('visible');
        }
    }


    init() {
        this.paginationManager();
        this.addPaginationButtonListener();
        this.setNewsVisibility();
    }
}

export default NewsListComponent;